import styled from "styled-components";

export const TableChartWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  .border-top-none {
    border-top: none !important;
  }
  .margin-top-2 {
    margin-top: 2px;
  }
  .title-content {
    color: #0089cf;
    font-weight: 700;
  }
  .padding-left-30 {
    padding-left: 30px !important;
  }
  .background-color {
    background-color: #0089cf;
    color: white;
  }
  .warning {
    color: tomato;
    text-decoration: underline;
  }
  .header-chart {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #C0C1C2;
    .criteria {
      padding: 4px 4px;
      width: 52%;
      font-weight: 500;
    }
    .quarter {
      padding: 4px 0;
      width: 6%;
      text-align: center;
      font-weight: 500;
      font-size: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
